// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'time-sheets/archive',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-time-sheets" */ '@/pages/[organisation]/hr/team-member-time-sheets/archived-team-member-time-sheets.vue'),
        name: 'human-resource.team-member-time-sheets.archived-team-member-time-sheets',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.timesheet.update-team-member-time-sheet',
        },
    },
    {
        path: 'time-sheets/archive/:timeSheetId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-time-sheets" */ '@/pages/[organisation]/hr/team-member-time-sheets/archived-team-member-time-sheet/[id].vue'),
        name: 'human-resource.team-member-time-sheets.view-archived-team-member-time-sheet',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.timesheet.update-team-member-time-sheet',
        },
    },

    {
        path: 'time-sheets',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-time-sheets" */ '@/pages/[organisation]/hr/team-member-time-sheets/team-member-time-sheets.vue'),
        name: 'human-resource.team-member-time-sheets.search-team-member-time-sheets',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.timesheet.view-team-member-time-sheets',
        },
    },
    {
        path: 'time-sheets/new',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-time-sheets" */ '@/pages/[organisation]/hr/team-member-time-sheets/team-member-time-sheet/new.vue'),
        name: 'human-resource.team-member-time-sheets.create-team-member-time-sheet',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.timesheet.create-team-member-time-sheet',
        },
    },
    {
        path: 'time-sheets/:timeSheetId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-time-sheets" */ '@/pages/[organisation]/hr/team-member-time-sheets/team-member-time-sheet/[id].vue'),
        name: 'human-resource.team-member-time-sheets.view-team-member-time-sheet',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.timesheet.view-team-member-time-sheets',
        },
    },
    {
        path: 'time-sheets/:timeSheetId/edit',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-time-sheets" */ '@/pages/[organisation]/hr/team-member-time-sheets/team-member-time-sheet/[id]/edit.vue'),
        name: 'human-resource.team-member-time-sheets.update-team-member-time-sheet',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.timesheet.update-team-member-time-sheet',
        },
    },
];
